import * as stylex from '@stylexjs/stylex'

export const elevationTop = stylex.defineVars({
  elevation0: 'none',
  elevation2: '0px -2px 4px 0px rgba(0, 0, 0, 0.16)',
  elevation4: '0px -2px 8px 0px rgba(0, 0, 0, 0.12)',
  elevation6: '0px -4px 10px 0px rgba(0, 0, 0, 0.12)',
  elevation8: '0px -4px 12px 0px rgba(0, 0, 0, 0.12)',
  elevation12: '0px -5px 16px 0px rgba(0, 0, 0, 0.12)',
  elevation16: '0px -6px 20px 0px rgba(0, 0, 0, 0.12)',
})

export type ElevationTop = typeof elevationTop

export const elevationBottom = stylex.defineVars({
  elevation0: 'none',
  elevation2: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)',
  elevation4: '0px 2px 8px 0px rgba(0, 0, 0, 0.12)',
  elevation6: '0px 4px 10px 0px rgba(0, 0, 0, 0.12)',
  elevation8: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
  elevation12: '0px 5px 16px 0px rgba(0, 0, 0, 0.12)',
  elevation16: '0px 6px 20px 0px rgba(0, 0, 0, 0.12)',
})

export type ElevationBottom = typeof elevationBottom
